import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { IQuestionConfig, elementTypes, elementIconById, QuestionState } from '../models/index';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'question-runner',
  templateUrl: './question-runner.component.html',
  styleUrls: ['./question-runner.component.scss']
})
export class QuestionRunnerComponent implements OnInit, OnChanges {

  @Input() currentQuestion:IQuestionConfig;
  @Input() currentQuestionIndex:number;
  @Input() totalQuestions:number;
  @Input() questionState:any;
  @Input() isSubmitted:boolean;

  questionTextSize = new FormControl(1);

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(){
    // if (this.lastTrackedQuestion !== this.currentQuestion){
    //   this.lastTrackedQuestion = this.currentQuestion;
    // }
    // if (this.lastTrackedQuestionStateMaster !== this.questionStateMaster){
    //   if (!this.questionStateMaster){
    //     this.questionState = new Map();
    //   }
    //   else{
    //     this.questionState = this.questionStateMaster;
    //   }
    //   this.lastTrackedQuestionStateMaster = this.questionState;
    // }
  }

  isInputLocked(){
    return this.isSubmitted;
  }

  getIconByElementTypeId(elementTypeId:string){
    return elementIconById.get(elementTypeId);
  }

}
